var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuIcSetting = function SvgMenuIcSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.89 0h24v24h-24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5C0",
    stroke: "#131317",
    strokeWidth: 1.2,
    d: "m20.371 12.504 1.287 1.145a1.295 1.295 0 0 1 .278 1.664l-1.55 2.65c-.121.202-.293.37-.499.485a1.42 1.42 0 0 1-1.115.112l-1.647-.543q-.432.277-.9.496l-.345 1.67a1.32 1.32 0 0 1-.482.774c-.251.196-.562.3-.88.293h-3.212a1.38 1.38 0 0 1-.88-.293 1.32 1.32 0 0 1-.48-.775l-.347-1.669a9 9 0 0 1-.893-.498l-1.652.545a1.42 1.42 0 0 1-1.114-.112 1.34 1.34 0 0 1-.498-.484l-1.607-2.651a1.295 1.295 0 0 1 .28-1.69L5.398 12v-.504l-1.286-1.145a1.295 1.295 0 0 1-.279-1.664l1.607-2.65c.12-.202.292-.37.498-.485.208-.115.44-.176.678-.178q.222-.013.436.04l1.62.57q.433-.278.899-.497l.347-1.67c.064-.306.234-.58.48-.774.252-.196.562-.3.88-.293h3.185a1.38 1.38 0 0 1 .88.293c.248.195.42.47.48.775l.348 1.669q.462.22.892.498l1.654-.544a1.4 1.4 0 0 1 1.115.111c.207.117.377.285.498.484l1.605 2.651a1.295 1.295 0 0 1-.259 1.69l-1.306 1.112z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131317",
    strokeWidth: 1.2,
    d: "M16.446 12a3.558 3.558 0 1 1-7.115 0 3.558 3.558 0 0 1 7.115 0Z"
  })));
};
export default SvgMenuIcSetting;